export const TARIFF_CALC_STRINGS = {
  emailCtaTitle: 'Enter your details to receive the full cost model.',
  emailCtaSubtitlePrefix:
    "We'll include our model's strategic insight into how you can reduce the cost of",
  successMessage: "Thanks, we'll be in touch!",
  firstNameLabel: 'First name',
  lastNameLabel: 'Last name',
  emailPlaceholder: 'Enter your business email',
  submitLabel: 'Submit',
  firstNameRequired: 'First name is required',
  lastNameRequired: 'Last name is required',
  emailRequired: 'Email is required',
  calculatingHeader: 'Calculating tariffs...',
  calculatingHTSCodes: 'Classifying HTS codes and estimating tariff impact',
  calculatingShouldCost: 'Calculating should-cost and key cost drivers',
  calculatingAlternativeSourcing: 'Evaluating alternative sourcing scenarios',
  whatIsAdditionalRate: 'What is Additional Rate?',
  additionalRateTooltip:
    'Additional duties applied based on applicable trade regulations (e.g., IEEPA-related rules), added on top of the base tariff.',
  shouldCost: 'Should Cost',
  topCostContributors: 'Top Cost Contributors',
  copied: 'Copied!',
  copyHTSCode: 'Copy HTS Code',
  usd: 'USD',
  topSourcingRecommendations: 'Top Sourcing Recommendations',
  alternativeSourcing: 'Alternative Sourcing',
  estimatedCostImpact: 'Estimated Cost Impact',
  currentSourcedFrom: 'Current Sourced From',
  expertHelpButtonText: 'Talk to an Expert',
  reportDeliveryTimeNotice:
    "The data above is instant. The full analysis models your product more deeply, which takes a few minutes. We'll email it to you as soon as it's ready.",
  fullReportUnlocked: 'Full Report Unlocked. Your Product Model Is on the Way!',
  fullReportUnlockedSubtitle:
    'Our system is processing the data, which usually takes about 5-10 minutes.\nOnce it’s ready, you’ll receive the full results directly at your email.\n\nWant help making sense of your results? Book a quick call with our team.',
} as const
